// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card{background:#fff;box-shadow:0 2px 8px rgba(0,0,0,.26);border-radius:2px}", "",{"version":3,"sources":["webpack://./src/components/Card/Card.scss"],"names":[],"mappings":"AAAA,MACE,eAAA,CACA,oCAAA,CACA,iBAAA","sourcesContent":[".card {\n  background: rgba(255, 255, 255, 1.0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n  border-radius: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
